module.exports = __webpack_public_path__ + "fonts/alex-brush-regular.ttf";